import React, { useState, useEffect } from 'react';
import { signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import { Link, useNavigate } from 'react-router-dom';

const StudentLogin: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Zaten giriş yapılmışsa portala yönlendir
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, u => {
      if (u) navigate('/student/portal', { replace: true });
    });
    return unsub;
  }, [navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/student/portal', { replace: true });
    } catch (err: any) {
      const code = err?.code || '';
      if (code === 'auth/user-not-found' || code === 'auth/wrong-password' || code === 'auth/invalid-credential') {
        setError('E-posta veya şifre hatalı. Lütfen tekrar deneyin.');
      } else if (code === 'auth/too-many-requests') {
        setError('Çok fazla başarısız deneme. Lütfen bir süre bekleyin.');
      } else if (code === 'auth/operation-not-allowed') {
        setError('E-posta/şifre girişi henüz aktif edilmemiş. Firebase Console → Authentication → Sign-in method bölümünden Email/Password seçeneğini etkinleştirin.');
      } else {
        setError(`Giriş yapılamadı: ${code || 'Bilinmeyen hata'}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="st-auth-bg">
      <div className="st-auth-card">
        <div className="st-auth-logo">
          <div className="st-auth-seal">
            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="2" fill="none"/>
              <path d="M24 8L26.5 15.5H34.5L28 20L30.5 27.5L24 23L17.5 27.5L20 20L13.5 15.5H21.5L24 8Z" fill="currentColor"/>
              <circle cx="24" cy="32" r="4" fill="currentColor"/>
            </svg>
          </div>
          <h1>University of American Atlantic</h1>
          <p>Öğrenci Bilgi Sistemi</p>
        </div>

        <div className="st-auth-divider" />

        <h2 className="st-auth-title">Öğrenci Girişi</h2>

        <form onSubmit={handleSubmit} className="st-auth-form">
          <div className="st-form-group">
            <label>E-posta Adresi</label>
            <input
              type="email"
              value={email}
              onChange={e => { setEmail(e.target.value); setError(''); }}
              placeholder="ornek@uaa.edu"
              required
              autoFocus
            />
          </div>
          <div className="st-form-group">
            <label>Şifre</label>
            <input
              type="password"
              value={password}
              onChange={e => { setPassword(e.target.value); setError(''); }}
              placeholder="Şifrenizi girin"
              required
            />
          </div>

          {error && <div className="st-auth-error">{error}</div>}

          <button type="submit" className="st-auth-btn" disabled={loading}>
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>
        </form>

        <p className="st-auth-footer">
          Hesabınız yok mu?{' '}
          <Link to="/student/register" className="st-auth-link">Kayıt Ol</Link>
        </p>
      </div>
    </div>
  );
};

export default StudentLogin;
